import { connect } from 'react-redux'
import L10nWrapper from 'common/components/l10n/L10nWrapper'
import { getLanguageCode } from 'tickets/redux/modules/user/selectors'

const mapStateToProps = state => ({
  languageCode: getLanguageCode(state),
})

export default connect(
  mapStateToProps
)(L10nWrapper)
